@let content = contentSg();
@let disabled = disabledSg();
@let isScrollable = isScrollableSg();
@let textareaHeightPx = textareaHeightPxSg();
@let assistantDisplays = assistantDisplaysSg();
@let assistantSelectionDisabled = assistantSelectionDisabledSg();
@let selectedFiles = selectedFilesSg();
@let allowFileAttachments = allowFileAttachmentsSg();
@let isDraggingOver = isDraggingOverSg();
@let effectiveKnowledgeBaseRetrievalRecords =
  effectiveKnowledgeBaseRetrievalRecordsSg();
@let isKnowledgeBaseRetrievalLocked = isKnowledgeBaseRetrievalLockedSg();
@let showKnowledgeBaseRetrievalDialog = showKnowledgeBaseRetrievalDialogSg();

<div
  class="atn-message-input"
  [class.atn-message-input--drag-over]="isDraggingOver && allowFileAttachments"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave($event)"
  (drop)="onDrop($event)"
>
  <p class="atn-message-input__disclaimer">
    AI can make mistakes. Please double check responses.
  </p>
  <div class="atn-message-input__wrapper">
    @if (isDraggingOver && allowFileAttachments) {
      <div class="atn-message-input__drop-overlay">
        <i class="atn-icon atn-upload atn-blue"></i>
        <span>Drop files here</span>
      </div>
    }
    @if (allowFileAttachments && selectedFiles.length > 0) {
      <div class="atn-message-input__files">
        @for (file of selectedFiles; track $index) {
          <div class="atn-message-input__file">
            <i class="atn-icon atn-file atn-blue"></i>
            <span class="atn-message-input__file-name">{{ file.name }}</span>
            <button
              type="button"
              class="atn-message-input__file-remove"
              (click)="removeFile($index)"
              title="Remove file"
            >
              <i class="atn-icon atn-close atn-red"></i>
            </button>
          </div>
        }
      </div>
    }
    @if (fileErrorSg(); as fileError) {
      <div
        class="atn-message-input__file-error"
        role="alert"
      >
        {{ fileError }}
      </div>
    }
    <textarea
      #textarea
      class="atn-message-input__textarea"
      [disabled]="disabled"
      [(ngModel)]="contentSg"
      (keydown.enter)="onEnterHandler($event)"
      [style.height.px]="textareaHeightPx"
      placeholder="Ask me anything..."
      rows="1"
      [class.atn-message-input__textarea--scrollable]="isScrollable"
    ></textarea>
    <div class="atn-message-input__buttons">
      @if (assistantDisplays.length >= 2) {
        <atn-assistant-switcher
          [assistants]="assistantDisplays"
          [disabled]="assistantSelectionDisabled"
          [(selectedAgentId)]="selectedAgentIdSg"
          class="atn-assistant__switcher"
        />
      }

      @let btnDisabled =
        disabled || (!content.length && selectedFiles.length === 0);

      <div class="atn-message-input__action-buttons">
        <button
          type="button"
          class="atn-message-input__knowledge-base-retrieval-button"
          [class.atn-message-input__knowledge-base-retrieval-button--active]="
            !!effectiveKnowledgeBaseRetrievalRecords?.length
          "
          [class.atn-message-input__knowledge-base-retrieval-button--locked]="
            isKnowledgeBaseRetrievalLocked
          "
          [disabled]="disabled"
          (click)="onKnowledgeBaseRetrievalClick()"
          [title]="
            isKnowledgeBaseRetrievalLocked
              ? 'Context provided by workspace (read-only)'
              : 'Add knowledge base retrieval records'
          "
        >
          <i class="atn-icon atn-settings atn-blue"></i>
        </button>
        @if (allowFileAttachments) {
          <input
            #fileInput
            type="file"
            class="atn-message-input__file-input"
            (change)="onFileSelected($event)"
            multiple
            [accept]="acceptedFileTypes"
          />
          <button
            type="button"
            class="atn-message-input__attach-button"
            [disabled]="disabled"
            (click)="onAttachFileClick()"
            title="Attach file"
          >
            <i class="atn-icon atn-upload atn-blue"></i>
          </button>
        }
        <button
          class="atn-message-input__submit-button"
          [class.atn-message-input__submit-button--disabled]="btnDisabled"
          [disabled]="btnDisabled"
          (click)="onSubmitClick()"
        >
          <img
            class="atn-message-input__logo-img"
            src="assets/img/attain-mark.png"
            alt="Attain Apps logo mark"
          />
        </button>
      </div>
    </div>
  </div>
</div>

@if (showKnowledgeBaseRetrievalDialog) {
  <atn-assistant-knowledge-base-retrieval-dialog
    [records]="effectiveKnowledgeBaseRetrievalRecords"
    [readonly]="isKnowledgeBaseRetrievalLocked"
    (save)="onKnowledgeBaseRetrievalSave($event)"
    (cancel)="onKnowledgeBaseRetrievalCancel()"
  />
}
